import { render, staticRenderFns } from "./addParticipants.modal.vue?vue&type=template&id=6c3921dc&"
import script from "./addParticipants.modal.vue?vue&type=script&lang=js&"
export * from "./addParticipants.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports